import React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { MenuItem, Select, FormControl, InputLabel } from '@material-ui/core';
import type { User } from '../../../models/user';

interface Props {
  value: string;
  onChange: (value: User['status']) => void;
  disabled: boolean;
}

export const UserStatusSelector: React.FunctionComponent<Props> = ({
  value,
  onChange,
  disabled,
}) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as User['status']);
  };

  const options = useOptions(intl);

  return (
    <FormControl variant="outlined" fullWidth required>
      <InputLabel id="status-selector-label" required>
        {intl.formatMessage({ id: 'status.label', defaultMessage: 'Status' })}
      </InputLabel>
      <Select
        labelId="status-selector-label"
        value={value}
        onChange={handleChange}
        label={intl.formatMessage({
          id: 'status.label',
          defaultMessage: 'Status',
        })}
        required
        disabled={disabled}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const useOptions = (intl: IntlShape): { value: string; text: string }[] => {
  return [
    {
      value: 'pending',
      text: intl.formatMessage({
        id: 'pendingCased',
        defaultMessage: '',
      }),
    },
    {
      value: 'active',
      text: intl.formatMessage({
        id: 'activeCased',
        defaultMessage: '',
      }),
    },
    {
      value: 'deleted',
      text: intl.formatMessage({
        id: 'deletedCased',
        defaultMessage: '',
      }),
    },
    {
      value: 'suspend',
      text: intl.formatMessage({
        id: 'suspendedCased',
        defaultMessage: '',
      }),
    },
  ];
};
